const enum ExportStatus {
  UNKNOWN = 'unknown',
  COMPLETED = 'completed',
  PENDING = 'pending',
  ERROR = 'failed'
}

export { ExportStatus };
